// useTestimonials.ts
import { useQuery } from '@tanstack/react-query';
import { testimonialService } from '@/services/testimonial.service';

export const useTestimonials = () => {


  return useQuery({
    queryKey: ['testimonials'],
    queryFn: () => {
      return testimonialService.getApprovedTestimonials();
    },
    staleTime: 5 * 60 * 1000, // 5 min cache
  });

}
